import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import './map.css'
import L from "leaflet";
import icon from '../../assets/favv-icon.png'
import 'leaflet/dist/leaflet.css';


const Mapcomponent = ({ lat, lng }) => {


  if (!lat || !lng) return <p>No location</p>;

  const customIcon = new L.Icon({
    iconUrl: icon,
    iconSize: [37, 38],
  });


    return (  


  <MapContainer
    center={[lat, lng]}
    zoom={13}
    className='main-map-view'
  >
    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
    <Marker position={[lat, lng]} icon={customIcon}>
      <Popup>Exhibition Location</Popup>
    </Marker>
  </MapContainer>



    );
}
 
export default Mapcomponent;